import {Routes} from "@angular/router";
import {WorkflowEndcustomerOneUpgradeSlaComponent} from "./workflow-endcustomer-one-upgrade-sla.component";

export const workflowEndcustomerOneUpgradeSlaRouting: Routes = [
    { path: 'upgrade-sla/:aid', component: WorkflowEndcustomerOneUpgradeSlaComponent, children: [
            { path: 'address', component: WorkflowEndcustomerOneUpgradeSlaComponent },
            { path: 'payment', component: WorkflowEndcustomerOneUpgradeSlaComponent },
            { path: 'checkout', component: WorkflowEndcustomerOneUpgradeSlaComponent },
            { path: 'complete', component: WorkflowEndcustomerOneUpgradeSlaComponent },
            { path: '', redirectTo: 'address', pathMatch: 'full' },
    ]},
]
